import React, { Component } from "react";
import {
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Input,
  Label,
  Collapse,
  Button,
  Table,
  CardFooter,
  Col,
  Badge,
} from "reactstrap";
import ContentWrapper from "../../../Layout/ContentWrapper";
import { format, parseISO } from "date-fns";
import { Spinner } from "../../../../common/components/spinner/spinner";
import Pagination from "react-js-pagination";
import Axios from "axios";
import formatValueCurrencyBRL from "../../../Utils/FormatCurrency/formatValueCurrency";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import Select from "react-select/";
import BasicAppState from "../../../../common/model/Singleton/BasicAppState";
import { URL_GalaxyPay } from "../../../Services/galaxyPayService";
import swal from "sweetalert";
import { IgicPayFinancialTransactionReport } from "./IgicPayFinancialTransactionReport";
import { URL_GateThree } from "../../../Services/gateThreeService";
import { da } from "date-fns/locale";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default class IgicPayFinancialTransactionForm extends Component {
  state = {
    accordionState: [true, false, false, false, false, false],
    modelFilter: {
      date: format(new Date(), "yyyy-MM-dd"),
      finalDate: format(new Date(), "yyyy-MM-dd"),
      idClient: 0,
      nameClient: "",
      status: "",
    },
    formTransactionsList: [],
    formFinancialAccount: [],
    loadingTable: false,
    listClients: [],
    currentPage: 1,
    itemsPerPage: 10,
    items: [],
  };

  toggleAccordion = (id) => {
    let accordionState = this.state.accordionState.map((val, i) => {
      return id === i ? !val : this.state.oneAtATime ? false : val;
    });
    this.setState({
      accordionState,
    });
  };

  setValues = (e, field) => {
    const { modelFilter } = this.state;
    modelFilter[field] = e;
    this.setState({ modelFilter });
  };

  setValuesPagination = async (s, n) => {
    const { modelFilter } = this.state;
    modelFilter["pageNumber"] = n;
    modelFilter["pageSize"] = s;
    this.setState({ modelFilter });
  };

  objectFilters(print) {
    const { modelFilter, formTransactionsList } = this.state;
    return {
      startDate: modelFilter.date,
      endDate: modelFilter.finalDate,
      idClient: modelFilter.idClient,
      status: modelFilter.status,
    };
  }

  checkMovement = async (print) => {
    this.setState({ loadingTable: true });
    await Axios.get(`${URL_GateThree}/pixbilling/list`, {
      params: this.objectFilters(print),
    })
      .then((resp) => {
        const { data } = resp;
        if (data.error) {
          this.SweetAlert(data.error);
        } else {
          this.setState({ formTransactionsList: data.items });
        }
      })
      .catch((e) => {
        this.setState({ loadingTable: false });
      });
    this.setState({ loadingTable: false });
  };

  printView = async () => {
    await this.checkMovement(true);
    const { modelFilter, formTransactionsList } = this.state;
    const classView = new IgicPayFinancialTransactionReport();
    const document = classView.generateDocument(
      {
        clinic: await new BasicAppState().getClinic(),
        initialDate: modelFilter.date,
        finalDate: modelFilter.finalDate,
      },
      formTransactionsList
    );
    pdfMake.createPdf(document).open({}, window.open("", "_blank"));
  };

  componentDidMount() {
     this.getWallet();
  }

  getWallet = async () => {
    this.setState({ loadingTable: true });

    await Axios.get(`${URL_GateThree}/getWallet`).then((resp) => {
      const { data } = resp;
      if (data) {
        this.setState({
          totalBalanceEmReais: data.totalBalanceEmReais ,
          loadingTable: false,
        });
      }
    }).catch((e) => {
      this.setState({ loadingTable: false });
    })
  }

  SweetAlert = (e) => {
    swal({
      title: "Ops!",
      icon: "warning",
      content: {
        element: "p",
        attributes: {
          style: "text-align: center;",
          innerText: e,
        },
      },
    });
  };

  paginate = (pageNumber) => {
    this.setState({ currentPage: pageNumber });
  };

  PerPage = (pageSize) => {
    this.setState({ itemsPerPage: pageSize });
  };
  // Function to determine the status badge
  status = (status, date) => {
    const statusConfig = {
      ACTIVE: { text: "Ativo", variant: "primary" },
      PAID: { text: "Pago", variant: "success" },
      PENDING: { text: "Pendente", variant: "warning" },
      EXPIRED: { text: "Expirado", variant: "danger" },
      default: { text: status, variant: "primary" },
    };
    // Convert date to Date object if it isn't already
    const dueDate = new Date(date);
    // Create a new date that's 30 minutes after the due date
    const dueDatePlus30 = new Date(dueDate.getTime() + 30 * 60000);
    // Get current date
    const currentDate = new Date();

    // console.log("Due date:", dueDate);
    // console.log("Due date + 30 min:", dueDatePlus30);
    // console.log("Current date:", currentDate);

    if (currentDate > dueDatePlus30 && status !== "PAID") {
      status = "EXPIRED";
    }

    const config = statusConfig[status] || statusConfig.default;

    return (
      <Badge pill color={config.variant}>
        {config.text}
      </Badge>
    );
  };

  render() {
    const {
      loadingTable,
      formTransactionsList,
      currentPage,
      itemsPerPage,
      items,
      listClients,
    } = this.state;

    // const { results, pageSize, currentPage, rowCount } = formTransactionsList
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = formTransactionsList?.slice(
      indexOfFirstItem,
      indexOfLastItem
    );

    const totalPages = Math.ceil(formTransactionsList?.length / itemsPerPage);
    return (
      <div>
        <ContentWrapper>
          <p className="content-heading">Registro de Transações</p>

          <div id="accordion">
            {/* Checkout Method */}
            <div className="card b mb-2">
              <CardHeader onClick={() => this.toggleAccordion(0)}>
                <CardTitle tag="h4">
                  <a className="text-inherit">
                    <small>
                      <em className="fa fa-filter text-primary mr-2"></em>
                    </small>
                    <span>Filtros</span>
                  </a>
                </CardTitle>
              </CardHeader>
              <Collapse isOpen={this.state.accordionState[0]}>
                <CardBody id="collapse01">
                  <Row>
                    <div className="col">
                      <Label>Data Inicial:</Label>
                      <Input
                        type="date"
                        id="date"
                        name="date"
                        value={this.state.modelFilter.date}
                        onChange={(e) => this.setValues(e.target.value, "date")}
                      />
                    </div>
                    <div className="col">
                      <Label>Data Final:</Label>
                      <Input
                        type="date"
                        id="finalDate"
                        name="finalDate"
                        value={this.state.modelFilter.finalDate}
                        onChange={(e) =>
                          this.setValues(e.target.value, "finalDate")
                        }
                      />
                    </div>

                    {/* <div className="col">
                      <Label>Cliente:</Label>
                      <Select
                        options={listClients}
                        onChange={(e) => this.setValues(e?.value, "idClient")}
                        isClearable
                        placeholder=""
                      />
                    </div> */}
                    <div className="col">
                      <Label>Status:</Label>
                      <Input
                        type="select"
                        name="status"
                        onChange={(e) =>
                          this.setValues(e.target.value, "status")
                        }
                        value={this.state.modelFilter.status}
                      >
                        <option value="">Selecione</option>
                        <option value="ACTIVE">Ativo</option>
                        <option value="PAID">Pago</option>
                      </Input>
                    </div>
                  </Row>
                  <br />
                  <Row className="mt-2">
                    <Col>
                      <Button
                        onClick={(e) => this.checkMovement(false)}
                        color="primary"
                      >
                        Pesquisar
                      </Button>
                    </Col>
                    <Col className="text-right">
                      <Button onClick={(e) => this.printView()} color="success">
                        Imprimir
                      </Button>
                    </Col>
                  </Row>
                </CardBody>
              </Collapse>
            </div>
          </div>
          <div className="card b mt-4">
            {loadingTable ? (
              <Spinner />
            ) : (
              <div>
                <Table size="sm" striped responsive>
                  <thead className="thead-light">
                    <tr className="text-center">
                      <th>Código Pix</th>
                      <th>Cliente</th>
                      <th>Descrição</th>
                      <th>Status</th>
                      <th>Vencimento</th>
                      <th>Valor</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.map((s, i) => (
                      <tr key={i} className="text-center">
                        <td style={{ maxWidth: "150px", paddingLeft: "24px" }}>
                          {s.emv}
                        </td>
                        <td>{s.customer?.name || "-"}</td>
                        <td>{s.description}</td>
                        <td>{this.status(s.status, s.dueDate)}</td>
                        <td>{format(parseISO(s.dueDate), "dd/MM/yyyy")}</td>
                        <td>{formatValueCurrencyBRL(s.amountEmReais)}</td>
                      </tr>
                    ))}
                    {formTransactionsList.length > 0 ? (
                      <tr className="p-3" style={{ background: "#F7F7F7" }}>
                        <td colSpan={3}>
                          <strong>Resultados: </strong>
                          <strong>{formTransactionsList.length}</strong>
                        </td>
                        <td className="text-right" colSpan={7}>
                          <strong>Valor total: </strong>
                          <strong>
                            {formatValueCurrencyBRL(
                              formTransactionsList.reduce(
                                (a, b) => a + b.amountEmReais,
                                0
                              )
                            )}
                          </strong>
                        </td>
                      </tr>
                    ) : null}
                  </tbody>
                </Table>

                <CardFooter>
                  <div className="d-flex align-items-left">
                    <div>
                      <select
                        className="custom-select"
                        name="selectOptionAmount"
                        onChange={(pageSize) => {
                          this.PerPage(pageSize.target.value);
                        }}
                        multiple=""
                      >
                        <option>10</option>
                        <option defaultValue="1">25</option>
                        <option defaultValue="2">50</option>
                        <option defaultValue="3">100</option>
                      </select>
                    </div>
                    <div className="ml-auto">
                      <span className="text-muted">
                        Saldo da carteira:
                        {formatValueCurrencyBRL(
                          this.state?.totalBalanceEmReais
                        )}{" "}
                      </span>
                    </div>
                    <div className="ml-auto">
                      <Pagination
                        activePage={currentPage}
                        totalItemsCount={formTransactionsList.length}
                        itemsCountPerPage={itemsPerPage}
                        onChange={(pageNumber) => {
                          this.paginate(pageNumber);
                        }}
                        itemClass="page-item"
                        linkClass="page-link"
                        firstPageText="Primeira"
                        lastPageText="Última"
                      />
                    </div>
                  </div>
                </CardFooter>
              </div>
            )}
          </div>
        </ContentWrapper>
      </div>
    );
  }
}
